import React, { useState, useCallback } from "react";
import MainToolbar from "../MainToolbar";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  Paper,
  Button,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  DialogActions,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import t from "../common/localization";
import EditCollectionView from "../EditCollectionView";
import { formatDate } from "../common/formatter";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import { blue, grey } from "@material-ui/core/colors";
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "../store";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "material-ui-search-bar";
import Dialog from "@material-ui/core/Dialog";
import { debounce } from "lodash";
import { DataGrid } from "@material-ui/data-grid";

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "white",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  iconButtons: {
    display: "flex",
    margin: theme.spacing(0.5),
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#EFEFEF",
    margin: "2px",
  },
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 688,
  },
}));

const ShareLocationData = [
  {
    time: "60",
    label: "1 Hour",
  },
  {
    time: "1440",
    label: "1 Day",
  },
  {
    time: "10080",
    label: "7 Days",
  },
  {
    time: "259200",
    label: "6 Months",
  },
  {
    time: "518400",
    label: "1 Year",
  },
];


const ShareLocationModal = (props) => {
  const { onClose, openData } = props;
  const { open, device } = openData;
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleListItemClick = async (item) => {
    setLoading(true);
    const requestBody = {
      deviceIds: device,
      time: item.time,
      attributes: {},
      id: 0,
    };
    try {
      const response = await fetch(`/api/android/getDevicesLocationShareLink`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setResponseMessage(data.message);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog width="lg" open={open} onClose={handleClose}>
      <DialogTitle>Select Time Interval For Live Location sharing</DialogTitle>
      <DialogContent>
        <List>
          {ShareLocationData.map((item) => (
            <ListItem
              button
              onClick={() => handleListItemClick(item)}
              key={item.time}
            >
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>
        {responseMessage && (
          <Typography
            variant="body1"
            color="textPrimary"
            style={{ marginTop: 16 }}
          >
            {responseMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        {loading && <CircularProgress />}
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DevicesView = ({ updateTimestamp, handleOnEdit, handleOnRemove }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isShowUser, setIsShowUser] = useState(false);
  const operatingUser = useSelector((state) => state.session.user);
  const prepaidUser = operatingUser.prepaid;
  const [items, setItems] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [deviceUsers, setDeviceUsers] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openShareLocation, setOpenShareLocation] = React.useState({
    open: false,
    device: null,
  });
  const getResult = async (val) => {
    dispatch(showLoaderStateActions.addState(true));
    const data = { search: val, page: 0, size: 50 };

    const response = await fetch("/api/android/searchDevice", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setSearchList(res);
    }
  };
  const debounceFn = useCallback(debounce(getResult, 1500), []);

  const getAllList = async () => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch("/api/devices");
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setSearchList(res);
    }
  };

  const searchChange = async (val) => {
    if (val && val.length > 3) {
      debounceFn(val);
    }
  };

  const reset = () => {
    console.log("val");
  };

  const showUsers = async (deviceID) => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch(
      `/api/android/deviceUsers?deviceId=${deviceID}`
    );
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setDeviceUsers(res);
    }
    setIsShowUser(true);
  };
  const handleClose = () => {
    setIsShowUser(false);
  };
  const handleOnRenew = async (device) => {
    if(confirm("Do You Want To Extend Device Expiry!")){
      dispatch(showLoaderStateActions.addState(true));

      const payload = {
        deviceId: device,
        userId: 0
      }
      console.log(payload);
      const response = await fetch("/api/devices/extendDeviceExpirationTime",{
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
          },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        const result = await response.json();
        setSearchList([]);
        alert("Expiry Extended Success Fully!")
      }
      dispatch(showLoaderStateActions.addState(false));
    }
  }

  const handleOnDeleteHistory = async (device) => {
    if(confirm("Do You Want To Delete Device History!")){
      dispatch(showLoaderStateActions.addState(true));
      
      //@GET("devices/{id}/deleteAllPositionsAndEvents")
    // Observable<Device> deleteAllPositionsAndEvents(@Path("id") long deviceId);
      const response = await fetch(`/api/devices/${device}/deleteAllPositionsAndEvents`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
          },
      });
      dispatch(showLoaderStateActions.addState(false));
      if (response.ok) {
        const result = await response.json();
        alert("Device History Deleted Successfully!")
      }
    }
  };

  const filterItems = searchList.sort(
    (a, b) =>
      new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime()
  );

  const handleOpenShareLocation = async () => {
    console.log(selectedRows);
    
    setOpenShareLocation({ open: true, device: selectedRows });
  }

  const handleCloseShareLocation = () => {
    setOpenShareLocation({ open: false, device: "" });
  };

  const columns = [
    { field: "name", headerName: t("settingsVehicleNumber"), width: 180 },
    { field: "username", headerName: t("deviceIdentifier"), width: 150 },
    { field: "phone", headerName: "VTS Number", width: 150 },
    { field: "email", headerName: t("deviceModel"), width: 120 },
    { field: "creationTime", headerName: "Creation Date", width: 150 },
    { field: "expirationTime", headerName: "Expiry Date", width: 150 },
    { field: "attachedUsers", headerName: "Attached Users", width: 150,
      renderCell: (params)=><>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            showUsers(params.value);
          }}
          >
          Show users
        </Button>
      </>
     },
     { field: "action", headerName: "Action", width: 400,
      renderCell: (params)=><>
        <div className={classes.iconButtons}>
          <Avatar className={classes.small}>
            {
              <IconButton onClick={(event) => handleOnEdit(params.value)}>
                <EditIcon
                  fontSize="small"
                  style={{ color: blue[600] }}
                  />
              </IconButton>
            }
          </Avatar>
          <Avatar className={classes.small} style={{marginLeft: "10px", marginRight: "10px"}}>
            {
              <IconButton
              onClick={(event) => handleOnRemove(params.value)}
              >
                <ClearIcon
                  fontSize="small"
                  style={{ color: grey[450] }}
                  />
              </IconButton>
            }
          </Avatar>
          {prepaidUser &&
            <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              handleOnRenew(params.value);
            }}
            >
              Extend Expiry
            </Button>
          }
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              handleOnDeleteHistory(params.value);
            }}
            >
              Delete History
          </Button>
        </div>
      </>
     },
     { field: "category", headerName: t("deviceCategory"), width: 150 },
     { field: "status", headerName: t("deviceStatus"), width: 200 },
     { field: "lastUpdate", headerName: t("deviceLastUpdate"), width: 200 },
     { field: "sim", headerName: t("deviceSim"), width: 200 },
     { field: "apn", headerName: t("deviceApn"), width: 200 },
     { field: "driverName", headerName: t("driverName"), width: 200 },
     { field: "contact", headerName: t("devicesContact"), width: 200 },
     { field: "remarks", headerName: t("reportRemarks"), width: 200 },
    ];
    
  const gridRows = filterItems.map((item, index) => ({
    id: item.id, // required unique id for DataGrid
    name: item.name,
    username: item.uniqueId,
    phone: item.phone,
    email: item.model,
    creationTime: formatDate(item.creationTime),
    expirationTime: formatDate(item.expirationTime),
    category: item.category,
    status: item.status,
    lastUpdate: formatDate(item.lastUpdate),
    attachedUsers: item.id,
    action: item.id,
    sim: item.attributes.sim,
    apn: item.attributes.apn,
    driverName: item.attributes.driverName,
    contact: item.contact,
    remarks: item.attributes.remarks,
  }));

  return (
    <>
      {openShareLocation.open && (
        <ShareLocationModal
          openData={openShareLocation}
          onClose={handleCloseShareLocation}
        />
      )}
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={isShowUser}
        maxWidth="sm"
      >
        <DialogTitle id="simple-dialog-title">Attached Users List</DialogTitle>
        <DialogContent>
          {!deviceUsers.length ? (
            <div> No User Attached !!</div>
          ) : (
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>User Name</TableCell>
                    <TableCell align="right">Phone</TableCell>
                    <TableCell align="right">Account Expiry Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {deviceUsers.map((user) => (
                    <TableRow key={user.name}>
                      <TableCell component="th" scope="row">
                        {user.name}
                      </TableCell>
                      <TableCell align="right">{user.phone}</TableCell>
                      <TableCell align="right">
                        {formatDate(user.expirationTime, "MMM D, YYYY")}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>
      <div style={{ marginBottom: "10px", display: "flex" }}>
        <SearchBar
          // value= {'search'}
          onChange={searchChange}
          onCancelSearch={reset}
          placeholder="Search here..."
          className="searchBarInput"
          style={{
            borderRadius: 15,
            height: 35,
            boxShadow: "2px 2px 2px 2px #dbddef",
            fontSize: 12,
            // marginBottom: "10px",
            width: "300px",
          }}
          // onRequestSearch={() => doSomethingWith()}
        />
        <Button
          variant="outlined"
          style={{ marginLeft: "10px" }}
          color="primary"
          onClick={getAllList}
        >
          Show All Devices
        </Button>

        <Button
          variant="outlined"
          style={{ marginLeft: "10px" }}
          color="primary"
          onClick={handleOpenShareLocation}
          disabled={selectedRows.length === 0}
        >
          Get Link
        </Button>

      </div>

      {/* <TableContainer className={classes.tContainer} component={Paper}>
        <Table
          stickyHeader
          aria-label="sticky table"
          className={classes.tableAction}
          size="small"
          style={{ whiteSpace: "nowrap" }}
        >
          <TableHead>
            <TableRow className={classes.rowAction}>
              <TableCell className={classes.tCell}>
                {t("settingsVehicleNumber")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("deviceIdentifier")}
              </TableCell>
              <TableCell className={classes.tCell}>{"VTS Number"}</TableCell>
              <TableCell className={classes.tCell}>
                {t("deviceModel")}
              </TableCell>
              <TableCell className={classes.tCell}>{"Creation Date"}</TableCell>
              <TableCell className={classes.tCell}>{"Expiry Date"}</TableCell>
              <TableCell className={classes.tCell}>
                {t("deviceCategory")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("deviceStatus")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("deviceLastUpdate")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {"Attached Users"}
              </TableCell>

              <TableCell className={classes.tCell}>{t("deviceSim")}</TableCell>
              <TableCell className={classes.tCell}>{t("deviceApn")}</TableCell>
              <TableCell className={classes.tCell}>{t("driverName")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("devicesContact")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportRemarks")}
              </TableCell>
              <TableCell className={classes.tCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {filterItems.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell>{<b>{item.name}</b>}</TableCell>
                <TableCell>{item.uniqueId}</TableCell>
                <TableCell>{item.phone}</TableCell>
                <TableCell>{item.model}</TableCell>
                <TableCell>
                  {formatDate(item.creationTime, "MMM D, YYYY")}
                </TableCell>
                <TableCell>
                  {formatDate(item.expirationTime, "MMM D, YYYY")}
                </TableCell>
                <TableCell>{item.category}</TableCell>
                <TableCell>{item.status}</TableCell>
                <TableCell>
                  {formatDate(item.lastUpdate, "MMM D, YYYY")}
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      showUsers(item);
                    }}
                  >
                    Show users
                  </Button>
                </TableCell>
                <TableCell>{item.attributes.sim}</TableCell>
                <TableCell>{item.attributes.apn}</TableCell>
                <TableCell>{item.attributes.driverName}</TableCell>
                <TableCell>{item.contact}</TableCell>
                <TableCell>{item.attributes.remarks}</TableCell>
                <TableCell className={classes.columnAction} padding="none">
                  <div className={classes.iconButtons}>
                    <Avatar className={classes.small}>
                      {
                        <IconButton onClick={(event) => handleOnEdit(item.id)}>
                          <EditIcon
                            fontSize="small"
                            style={{ color: blue[600] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                    <Avatar className={classes.small}>
                      {
                        <IconButton
                          onClick={(event) => handleOnRemove(item.id)}
                        >
                          <ClearIcon
                            fontSize="small"
                            style={{ color: grey[450] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      <DataGrid
        rows={gridRows}
        columns={columns}
        checkboxSelection
        autoHeight={false}
        pageSize={50}
        rowsPerPageOptions={[50, 100, 500]}
        style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
        onSelectionModelChange={(newSelection) => {
          setSelectedRows(newSelection);
        }}
        pagination
      />
    </>
  );
};

const DevicesPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView
        content={DevicesView}
        editPath="/device"
        endpoint="devices"
        successDialogShow={false}
      />
    </>
  );
};

export default DevicesPage;
